var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M319.192 199.736l-12.062 43.048-36.194-6.684-23.297-48.023-62.938 22.334-4.964-13.986-16.466-2.029 12.407 34.966 43.313-11.077 12.309 34.686-29.941 44.188 50.81 43.337-9.631 11.292 6.476 15.277 24.078-28.229-31.249-31.971 23.885-28.002 53.238 3.837 12.127-65.673 14.594 2.695 9.993-13.246-36.488-6.74zm-63.205 56.242z",
  fill: "#f0f0f0"
})));

export default SvgIm;